<template>
    <div class="d-flex mt-2 sticky-box justify-center">
      <v-btn @click="changeDiscounts()" large tile outlined class="link non-text-transformation" data-cy="max-button">
        {{ btnLabel }}
      </v-btn>
    </div>
  </template>
  
  <script>
  import { mapGetters, mapMutations } from 'vuex'
  import { GET_PRODUCT_TABLE, GET_PRODUCT_ID_LIST, GET_PRODUCT_MAX_DISCOUNT_RATES,
      GET_PRODUCT_STD_DISCOUNT_RATES, } from '@/store/modules/offer/getters'
import { SET_ALL_DISCOUNTS_OF_PRODUCT } from '../../store/modules/offer/mutations'
  
  export default {
    name: 'MaxDiscountsButton',
    computed: {
      ...mapGetters('offer', [
        GET_PRODUCT_TABLE,
        GET_PRODUCT_ID_LIST, 
        GET_PRODUCT_MAX_DISCOUNT_RATES,
        GET_PRODUCT_STD_DISCOUNT_RATES,
      ]),
      productsList() {
        return this[GET_PRODUCT_ID_LIST]
      },
      areMaxDiscountsReached() {
        for(const product of this[GET_PRODUCT_ID_LIST]) {
            const maxDiscountsRates = this[GET_PRODUCT_MAX_DISCOUNT_RATES](product)
            const productTable = this[GET_PRODUCT_TABLE](product)
            
            const someProductsAreNotMaxed = Object.keys(maxDiscountsRates).some(
                zoneId => productTable.discounts[zoneId] < maxDiscountsRates[zoneId]
            )

            if(someProductsAreNotMaxed) {
                return false
            }
        }

        return true
      },
      btnLabel() {
        return !this.areMaxDiscountsReached
          ? this.$t('STICKYBOX_BUTTON_MAX_DISCOUNTS')
          : this.$t('STICKYBOX_BUTTON_RESET_DISCOUNTS')
      },
    },
    methods: {
      ...mapMutations('offer', [SET_ALL_DISCOUNTS_OF_PRODUCT]),
      changeDiscounts() {
        this.areMaxDiscountsReached ? this.setAllDiscountsToStd() : this.setAllDiscountsToMax()
        
        this.validateAllDiscounts()
      },
      setAllDiscountsToMax() {
        for(const productId of this.productsList) {
            this[SET_ALL_DISCOUNTS_OF_PRODUCT]({
                productId: productId, 
                discountRates: this.getMaxDiscountByProductId(productId),
            })
        }
      },
      setAllDiscountsToStd() {
        for(const productId of this.productsList) {
            this[SET_ALL_DISCOUNTS_OF_PRODUCT]({
                productId: productId, 
                discountRates: this.getStandardDiscountByProductId(productId),
            })
        }
      },
      validateAllDiscounts(){
        for(const productId of this.productsList) {
            this.$root.$emit('validatePivotProduct', productId)
        }
      },
      getMaxDiscountByProductId(productId) {
        return this[GET_PRODUCT_MAX_DISCOUNT_RATES](productId)
      },
      getStandardDiscountByProductId(productId) {
        return this[GET_PRODUCT_STD_DISCOUNT_RATES](productId)
      }
    }
  }
  </script>
